if (!customElements.get('home-video')) {
  customElements.define('home-video', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.video = this.querySelector('video');
      this.section = this.closest('.video-section');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.addEventListener('playing', () => this.section.classList.add('video-section--played'));
      this.video.addEventListener('error', () => this.section.classList.remove('video-section--played'));
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.1 && !this.reducedMotion.matches) {
            if (!this.video.getAttribute('src')) {
              this.video.src = window.matchMedia('(max-width: 767px)').matches ? this.dataset.mobile : this.dataset.desktop;
              this.video.load();
            }
            const playing = this.video.play();
            if (playing) playing.catch(() => {});
          } else {
            this.video.pause();
          }
        });
      }, { rootMargin: '0px', threshold: 0.1 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }
  });
}
